import React from 'react'
import {connect} from 'react-redux'
import Modal from '../common/components/Modal'

import * as actions from '../interview/actions'
import { FormattedMessage } from "react-intl"

const EditConfirmModal = ({ approveEdit, cancelEdit, show }) =>
  show ? (
    <Modal
      heading={
        <FormattedMessage
          id="interview.modals.edit.header"
          defaultMessage="Edit answer?"
        />
      }
      body={
        <FormattedMessage
          id="interview.modals.edit.body"
          defaultMessage="This will delete any answers after it."
        />
      }
      buttonClick={approveEdit}
      cancelClick={cancelEdit}
      buttonText={
        <FormattedMessage
          id="interview.modals.button.continue"
          defaultMessage="Continue"
        />
      }
    />
  ) : (
    <span />
  )

const mapStateToProps = (state) => ({
  show: state.modals.editConfirm.needed
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  approveEdit: () => dispatch(actions.approveEdit(true)),
  cancelEdit: () => dispatch(actions.cancelEdit())
})

const EditConfirmModalContainer = connect(mapStateToProps, mapDispatchToProps)(EditConfirmModal)

export {EditConfirmModalContainer as default, EditConfirmModal}



// WEBPACK FOOTER //
// ./assets/modals/EditConfirmModal.js